// extracted by mini-css-extract-plugin
export default {"main":"cardsw_main__SG0+O","imgblock":"cardsw_imgblock__UAPsT","image":"cardsw_image__N9M1j"};